import {gql} from '@apollo/client';

export const userQueries = {
    USER_BY_ID: gql`
        query UserById($id: UUID!) {
            userById(id: $id) {
                id
                firstName
                lastName
                userName
                email
                phoneNumber
            }
        }
    `,
    ALL_USERS_BY_FILTER: gql`
        query allUserInfos($filter: UserInfoQueryFilterInput!) {
            allUserInfos(filter: $filter) {
                id
                email
                firstName
                lastName
            }
        }
    `,
};
